import { render } from "./FacetsList.vue?vue&type=template&id=47725406"
import script from "./FacetsList.vue?vue&type=script&lang=js"
export * from "./FacetsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__